import { Sparkles, Gift, Zap } from 'lucide-react';

export const ExclusiveOffers = () => {
  const handleBooking = (packageName) => {
    const message = encodeURIComponent(`Hi, I'd like to book the "${packageName}" package at Magic Touch Salon.`);
    window.open(`https://wa.me/919870214490?text=${message}`, '_blank');
  };

  const womenCombos = [
    {
      name: "The Makeover",
      price: "₹599",
      services: ["Hair Cut", "Hair Spa", "Blow Dry", "Hair Wash"],
      bonus: "FREE Foot Massage"
    },
    {
      name: "Glow Up",
      price: "₹799",
      services: ["Fruit Facial", "Pedicure", "Manicure", "De-Tan", "Threading"],
      bonus: "FREE Foot Massage"
    },
    {
      name: "Full Body Pamper",
      price: "₹999",
      services: ["Waxing (Full Arms & Legs)", "Mani/Pedi", "De-Tan/Clean Up"],
      bonus: "FREE Foot Massage"
    }
  ];

  const menCombos = [
    {
      name: "The Grooming Kit",
      price: "₹599",
      services: ["Hair Cut", "Shave", "Head Massage", "Choice of Hair Spa / Colour / De-Tan"],
      bonus: "FREE Foot Massage"
    },
    {
      name: "Pro Choice",
      price: "₹799",
      services: ["Pick ANY 5 Services", "Cut, Shave, Head Massage, Spa, Pedi, Mani, De-Tan"],
      bonus: "FREE Foot Massage"
    },
    {
      name: "Royal Treatment",
      price: "₹999",
      services: ["Pick ANY 5 Services", "Includes Facial & Clean Up options"],
      bonus: "FREE Foot Massage"
    }
  ];

  const hotDeals = [
    {
      name: "Root Touch Up Package",
      price: "₹1000",
      description: "Haircut + Colour + Wash + Blow Dry + Deep Conditioning",
      icon: Sparkles
    },
    {
      name: "Facial Festival",
      price: "Starting @ ₹550",
      description: "Flat 30% OFF on all Facial Treatments",
      badge: "30% OFF",
      icon: Gift
    },
    {
      name: "Manicure & Pedicure Combo",
      price: "₹650",
      description: "Complete hand and foot care package",
      icon: Zap
    }
  ];

  return (
    <section className="py-20 md:py-32 bg-gradient-to-b from-[#0A0A0A] to-[#121212]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-4">
            <Gift className="text-[#D4AF37]" size={48} />
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4 text-white">
            <span className="text-[#D4AF37]">🎉 Exclusive</span> Offers
          </h2>
          <p className="text-lg text-[#A3A3A3] max-w-2xl mx-auto">
            Limited time combo packages designed for your complete transformation
          </p>
        </div>

        {/* Women's Special Combos */}
        <div className="mb-16">
          <h3 className="text-3xl sm:text-4xl font-bold mb-8 text-white flex items-center gap-3">
            <span>👩</span> Women's Special Combos
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {womenCombos.map((combo, index) => (
              <div
                key={index}
                data-testid={`women-combo-${index + 1}`}
                className="bg-neutral-900 border-2 border-[#D4AF37]/30 p-8 hover:border-[#D4AF37] transition-all duration-300 relative overflow-hidden group"
              >
                <div className="absolute top-0 right-0 bg-[#D4AF37] text-black px-4 py-1 text-xs font-bold uppercase tracking-wider">
                  Popular
                </div>
                <div className="mt-6">
                  <h4 className="text-2xl font-bold text-white mb-2">{combo.name}</h4>
                  <div className="text-4xl font-bold text-[#D4AF37] mb-6">{combo.price}</div>
                  <ul className="space-y-3 mb-6">
                    {combo.services.map((service, idx) => (
                      <li key={idx} className="text-[#A3A3A3] flex items-start">
                        <span className="text-[#D4AF37] mr-2">✓</span>
                        <span>{service}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/30 p-3 mb-6 text-center">
                    <p className="text-[#D4AF37] text-sm font-semibold">
                      🎁 BONUS: {combo.bonus}
                    </p>
                  </div>
                  <button
                    data-testid={`book-women-combo-${index + 1}`}
                    onClick={() => handleBooking(combo.name)}
                    className="w-full bg-[#D4AF37] text-black font-semibold py-3 uppercase tracking-widest text-sm hover:bg-[#E5C15D] transition-all duration-300"
                  >
                    Book Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Men's Special Combos */}
        <div className="mb-16">
          <h3 className="text-3xl sm:text-4xl font-bold mb-8 text-white flex items-center gap-3">
            <span>👨</span> Men's Special Combos
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {menCombos.map((combo, index) => (
              <div
                key={index}
                data-testid={`men-combo-${index + 1}`}
                className="bg-neutral-900 border-2 border-[#D4AF37]/30 p-8 hover:border-[#D4AF37] transition-all duration-300 relative overflow-hidden group"
              >
                <div className="absolute top-0 right-0 bg-[#D4AF37] text-black px-4 py-1 text-xs font-bold uppercase tracking-wider">
                  Popular
                </div>
                <div className="mt-6">
                  <h4 className="text-2xl font-bold text-white mb-2">{combo.name}</h4>
                  <div className="text-4xl font-bold text-[#D4AF37] mb-6">{combo.price}</div>
                  <ul className="space-y-3 mb-6">
                    {combo.services.map((service, idx) => (
                      <li key={idx} className="text-[#A3A3A3] flex items-start">
                        <span className="text-[#D4AF37] mr-2">✓</span>
                        <span>{service}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/30 p-3 mb-6 text-center">
                    <p className="text-[#D4AF37] text-sm font-semibold">
                      🎁 BONUS: {combo.bonus}
                    </p>
                  </div>
                  <button
                    data-testid={`book-men-combo-${index + 1}`}
                    onClick={() => handleBooking(combo.name)}
                    className="w-full bg-[#D4AF37] text-black font-semibold py-3 uppercase tracking-widest text-sm hover:bg-[#E5C15D] transition-all duration-300"
                  >
                    Book Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Hot Deals */}
        <div>
          <h3 className="text-3xl sm:text-4xl font-bold mb-8 text-white flex items-center gap-3">
            <span>🔥</span> Hot Deals
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {hotDeals.map((deal, index) => {
              const Icon = deal.icon;
              return (
                <div
                  key={index}
                  data-testid={`hot-deal-${index + 1}`}
                  className="bg-gradient-to-br from-[#D4AF37]/20 to-[#121212] border-2 border-[#D4AF37] p-8 hover:shadow-[0_0_30px_rgba(212,175,55,0.5)] transition-all duration-300 relative overflow-hidden"
                >
                  {deal.badge && (
                    <div className="absolute top-4 right-4 bg-red-600 text-white px-3 py-1 text-xs font-bold uppercase tracking-wider rotate-12">
                      {deal.badge}
                    </div>
                  )}
                  <Icon className="text-[#D4AF37] mb-4" size={40} />
                  <h4 className="text-2xl font-bold text-white mb-2">{deal.name}</h4>
                  <div className="text-3xl font-bold text-[#D4AF37] mb-4">{deal.price}</div>
                  <p className="text-[#A3A3A3] mb-6">{deal.description}</p>
                  <button
                    data-testid={`book-hot-deal-${index + 1}`}
                    onClick={() => handleBooking(deal.name)}
                    className="w-full bg-[#D4AF37] text-black font-semibold py-3 uppercase tracking-widest text-sm hover:bg-[#E5C15D] transition-all duration-300"
                  >
                    Book Now
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center bg-neutral-900 border border-[#D4AF37]/30 p-8">
          <p className="text-[#A3A3A3] text-lg mb-4">
            ⏰ <span className="text-[#D4AF37] font-semibold">Limited Time Offers!</span> Book your combo package today.
          </p>
          <p className="text-white text-sm">
            Call us at <a href="tel:+919870214490" className="text-[#D4AF37] hover:underline">+91 98702 14490</a> for more details
          </p>
        </div>
      </div>
    </section>
  );
};
